import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { getExternalRegisterTypeIndicatorDots } from "./helpers";
import type { ExternalRegisterSummary } from "./types";

type ExternalRegisterDotProps = {
  alerts?: ExternalRegisterSummary[] | null;
  size?: number;
  label?: string;
};

export const ExternalRegisterDot: React.FC<ExternalRegisterDotProps> = ({
  alerts,
  size = 10,
  label,
}) => {
  const { t } = useTranslation();
  const dots = getExternalRegisterTypeIndicatorDots(alerts);
  if (dots.length === 0) return null;

  return (
    <Box
      component="span"
      role="img"
      aria-label={label ?? t("externalRegister.indicator.dotLabel")}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.35,
        verticalAlign: "middle",
      }}
    >
      {dots.map((dot) => (
        <Box
          key={dot.type}
          component="span"
          aria-hidden
          sx={{
            display: "inline-block",
            width: size,
            height: size,
            minWidth: size,
            borderRadius: "50%",
            backgroundColor: dot.color,
            boxShadow: "0 0 0 2px rgba(255, 255, 255, 0.95)",
          }}
        />
      ))}
    </Box>
  );
};

export default ExternalRegisterDot;
